export default "__VITE_ASSET__BZN3qj6B__"